import { render, staticRenderFns } from "./AssignTeam.vue?vue&type=template&id=1cfbe850&scoped=true"
import script from "./AssignTeam.vue?vue&type=script&lang=js"
export * from "./AssignTeam.vue?vue&type=script&lang=js"
import style0 from "./AssignTeam.vue?vue&type=style&index=0&id=1cfbe850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfbe850",
  null
  
)

export default component.exports